import { Action } from 'redux';
import { LoyaltyEstimate } from 'types/Loyalty';

export const LOYALTY_ESTIMATE_FETCH_START = 'loyalty/estimate_fetch_start';
export const LOYALTY_ESTIMATE_FETCH_SUCCESS = 'loyalty/estimate_fetch_success';

interface LoyaltyEstimateFetchStartAction extends Action<typeof LOYALTY_ESTIMATE_FETCH_START> {}

interface LoyaltyEstimateFetchSuccessAction extends Action<typeof LOYALTY_ESTIMATE_FETCH_SUCCESS> {
    payload: {
        estimate: LoyaltyEstimate;
    };
}

export type LoyaltyAction = LoyaltyEstimateFetchStartAction | LoyaltyEstimateFetchSuccessAction;
